<template>
  <div class="message-board">
    <!-- At init only -->
      <InitRecordRemind v-if="isInit()" :name="name" />
    
    <!-- every 4 weeks, start at init+1w-->
      <TargetsRemind v-if="isRecursive(1) && !isDone('targets')" :name="name" :callback="done" />
    
    <!-- if next sessions are planned for the week-->    
      <SessionRemaining v-if="countRemainingSessions > 0" :name="name" :count="countRemainingSessions" />
    
    <!-- if no more session for the week-->
      <SessionCompleted v-if="countRemainingSessions === 0" :name="name" :user="user" /> 
    
    <!-- every 4 weeks display and at init or waist not set-->
      <TrackBodyRemind v-if="remindTrackBody()" :name="name" :callback="done"  />
  </div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
import TrackBodyRemind from '@/components/cards/TrackBodyRemind'
import SessionCompleted from '@/components/cards/SessionCompleted'
import SessionRemaining from '@/components/cards/SessionRemaining'
import InitRecordRemind from '@/components/cards/InitRecordRemind'
import TargetsRemind from '@/components/cards/TargetsRemind'

export default {
  name: 'home',
  data () {
    return {
      user: undefined,
      name: undefined
    }
  },
  components: { TrackBodyRemind, SessionCompleted, SessionRemaining, InitRecordRemind, TargetsRemind },
  created () {
    this.user = api.getCurrentUser()
    this.name = this.user.athlete.name
  },
  mounted () {
    if (this.user.athlete.isFirstLogin) {
      M.TapTarget.init(this.$parent.$refs.tap, {}).open()
      this.user.athlete.isFirstLogin = false
      api.update(this.user)
    }
    // While activity changed reset the PSN
    this.$events.$on('selected-activity-changed', () => {
      const user = api.getCurrentUser()
      user.athlete.progSeqNum = 0
      api.update(user)
    })
  },
  computed: {
    countRemainingSessions: function () {
      return api.getNextSessions(this.user).length
    }
  },
  methods: {
    isInit: function () {
      return (!this.user.athlete.recordsInit) // is initialized?
    },
    remindTrackBody: function () {
      return (!this.user.athlete.waist || (this.isRecursive(2) && !this.isDone('trackBody')))
    },
    isRecursive: function (n, period = 4) {
      return (this.user.athlete.progSeqNum % period === n) // every n weeks, starting at t0+n
    },
    isDone: function (card) {
      if (!this.user.athlete.doneActions) return false
      return this.user.athlete.doneActions[card]
    },
    done: function (card) {
      if (!this.user.athlete.doneActions) this.user.athlete.doneActions = {}
      this.user.athlete.doneActions[card] = true
      api.update(this.user)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue